<div class="recargas-admin-container">
  <!-- Header -->
  <div class="admin-header">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="header-title">
          <i class="fas fa-cogs me-2"></i>Administración de Recargas
        </h4>
        <p class="header-subtitle text-muted">
          Gestiona el estado de operadoras, tipos de operadores y productos
        </p>
      </div>
      <div class="header-actions">
        <button type="button" 
                class="btn btn-outline-primary btn-sm"
                (click)="navigateToOperadoras()"
                title="Ir a la vista normal de recargas">
          <i class="fas fa-arrow-left me-1"></i>Ver Recargas
        </button>
      </div>
    </div>
  </div>

  <!-- Navigation Tabs -->
  <ul class="nav nav-tabs admin-tabs mb-4">
    <li class="nav-item">
      <button class="nav-link" 
              [class.active]="activeTab === 'operadoras'"
              (click)="setActiveTab('operadoras')">
        <i class="fas fa-sim-card me-2"></i>Operadoras
        <span class="badge bg-primary ms-2">{{ operadoras.length }}</span>
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link" 
              [class.active]="activeTab === 'tipos'"
              (click)="setActiveTab('tipos')"
              [disabled]="!selectedOperadora">
        <i class="fas fa-list me-2"></i>Tipos de Operadores
        <span class="badge bg-primary ms-2">{{ tiposOperadores.length }}</span>
      </button>
    </li>
    <li class="nav-item">
      <button class="nav-link" 
              [class.active]="activeTab === 'productos'"
              (click)="setActiveTab('productos')"
              [disabled]="!selectedTipoOperador">
        <i class="fas fa-box me-2"></i>Productos
        <span class="badge bg-primary ms-2">{{ productos.length }}</span>
      </button>
    </li>
  </ul>

  <!-- Tab Content -->
  <div class="tab-content">
    
    <!-- Operadoras Tab -->
    <div *ngIf="activeTab === 'operadoras'" class="tab-pane fade show active">
      
      <!-- Search Bar -->
      <div class="search-section mb-3">
        <div class="input-group">
          <span class="input-group-text">
            <i class="fas fa-search"></i>
          </span>
          <input type="text" 
                 class="form-control" 
                 placeholder="Buscar operadoras por nombre, código o descripción..."
                 [(ngModel)]="searchOperadoras">
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="loadingOperadoras" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-2 text-muted">Cargando operadoras...</p>
      </div>

      <!-- Operadoras List -->
      <div *ngIf="!loadingOperadoras" class="admin-list">
        <div *ngFor="let operadora of filteredOperadoras" 
             class="admin-item"
             [class.item-inactive]="!operadora.status">
          
          <div class="item-content">
            <!-- Logo -->
            <div class="item-logo">
              <img [src]="operadora.urlImag || '/assets/brandLogos/default.svg'" 
                   [alt]="operadora.name"
                   class="logo-img">
            </div>

            <!-- Info -->
            <div class="item-info">
              <h6 class="item-name">{{ operadora.name }}</h6>
              <p class="item-code text-muted">Código: {{ operadora.code }}</p>
              <p class="item-description text-muted">{{ operadora.description }}</p>
              <div class="item-metadata">
                <small class="text-muted">
                  Orden: {{ operadora.order }} | 
                  Cliente: {{ operadora.showClient ? 'Sí' : 'No' }} | 
                  Consola: {{ operadora.showConsole ? 'Sí' : 'No' }}
                </small>
              </div>
            </div>

            <!-- Actions -->
            <div class="item-actions">
              <!-- Status Toggle -->
              <div class="form-check form-switch">
                <input class="form-check-input" 
                       type="checkbox" 
                       [id]="'toggle-op-' + operadora.code"
                       [checked]="operadora.status"
                       [disabled]="togglingOperador[operadora.code]"
                       (change)="toggleOperadorStatus(operadora)">
                <label class="form-check-label" [for]="'toggle-op-' + operadora.code">
                  <span [class]="operadora.status ? 'text-success' : 'text-danger'">
                    {{ operadora.status ? 'Activa' : 'Inactiva' }}
                  </span>
                </label>
              </div>

              <!-- Load Types Button -->
              <button class="btn btn-outline-primary btn-sm"
                      [disabled]="loadingTipos"
                      (click)="loadTiposOperadores(operadora.code); setActiveTab('tipos')">
                <i class="fas fa-list me-1"></i>Ver Tipos
              </button>
            </div>
          </div>

          <!-- Loading overlay -->
          <div *ngIf="togglingOperador[operadora.code]" class="loading-overlay">
            <div class="spinner-border spinner-border-sm text-primary"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tipos de Operadores Tab -->
    <div *ngIf="activeTab === 'tipos'" class="tab-pane fade show active">
      
      <!-- Navigation Breadcrumb -->
      <nav aria-label="breadcrumb" class="mb-3">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#" (click)="setActiveTab('operadoras'); $event.preventDefault()">Operadoras</a>
          </li>
          <li class="breadcrumb-item active">Tipos de Operadores</li>
        </ol>
      </nav>

      <!-- Search Bar -->
      <div class="search-section mb-3">
        <div class="input-group">
          <span class="input-group-text">
            <i class="fas fa-search"></i>
          </span>
          <input type="text" 
                 class="form-control" 
                 placeholder="Buscar tipos de operadores..."
                 [(ngModel)]="searchTipos">
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="loadingTipos" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-2 text-muted">Cargando tipos de operadores...</p>
      </div>

      <!-- Tipos List -->
      <div *ngIf="!loadingTipos && selectedOperadora" class="admin-list">
        <div *ngFor="let tipo of filteredTiposOperadores" 
             class="admin-item"
             [class.item-inactive]="!tipo.status">
          
          <div class="item-content">
            <!-- Icon -->
            <div class="item-icon">
              <i class="fas fa-list-alt text-primary"></i>
            </div>

            <!-- Info -->
            <div class="item-info">
              <h6 class="item-name">{{ tipo.name }}</h6>
              <p class="item-code text-muted">Código: {{ tipo.code }}</p>
              <p class="item-description text-muted">{{ tipo.description }}</p>
              <div class="item-metadata">
                <small class="text-muted">
                  Orden: {{ tipo.order }} | 
                  Cliente: {{ tipo.showClient ? 'Sí' : 'No' }} | 
                  Consola: {{ tipo.showConsole ? 'Sí' : 'No' }}
                </small>
              </div>
            </div>

            <!-- Actions -->
            <div class="item-actions">
              <!-- Status Toggle -->
              <div class="form-check form-switch">
                <input class="form-check-input" 
                       type="checkbox" 
                       [id]="'toggle-tipo-' + tipo.code"
                       [checked]="tipo.status"
                       [disabled]="togglingTipo[tipo.code]"
                       (change)="toggleTipoOperadorStatus(tipo)">
                <label class="form-check-label" [for]="'toggle-tipo-' + tipo.code">
                  <span [class]="tipo.status ? 'text-success' : 'text-danger'">
                    {{ tipo.status ? 'Activo' : 'Inactivo' }}
                  </span>
                </label>
              </div>

              <!-- Load Products Button -->
              <button class="btn btn-outline-primary btn-sm"
                      [disabled]="loadingProductos"
                      (click)="loadProductos(selectedOperadora!, tipo.code); setActiveTab('productos')">
                <i class="fas fa-box me-1"></i>Ver Productos
              </button>
            </div>
          </div>

          <!-- Loading overlay -->
          <div *ngIf="togglingTipo[tipo.code]" class="loading-overlay">
            <div class="spinner-border spinner-border-sm text-primary"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Productos Tab -->
    <div *ngIf="activeTab === 'productos'" class="tab-pane fade show active">
      
      <!-- Navigation Breadcrumb -->
      <nav aria-label="breadcrumb" class="mb-3">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#" (click)="setActiveTab('operadoras'); $event.preventDefault()">Operadoras</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#" (click)="setActiveTab('tipos'); $event.preventDefault()">Tipos de Operadores</a>
          </li>
          <li class="breadcrumb-item active">Productos</li>
        </ol>
      </nav>

      <!-- Search Bar -->
      <div class="search-section mb-3">
        <div class="input-group">
          <span class="input-group-text">
            <i class="fas fa-search"></i>
          </span>
          <input type="text" 
                 class="form-control" 
                 placeholder="Buscar productos..."
                 [(ngModel)]="searchProductos">
        </div>
      </div>

      <!-- Loading State -->
      <div *ngIf="loadingProductos" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-2 text-muted">Cargando productos...</p>
      </div>

      <!-- Productos List -->
      <div *ngIf="!loadingProductos && selectedTipoOperador" class="admin-list">
        <div *ngFor="let producto of filteredProductos" 
             class="admin-item"
             [class.item-inactive]="!producto.status">
          
          <div class="item-content">
            <!-- Icon -->
            <div class="item-icon">
              <i class="fas fa-box text-success"></i>
            </div>

            <!-- Info -->
            <div class="item-info">
              <h6 class="item-name">{{ producto.name }}</h6>
              <p class="item-code text-muted">Código: {{ producto.code }}</p>
              <p class="item-description text-muted">{{ producto.description }}</p>
              
              <!-- Secuencia de Montos (si existe) -->
              <div *ngIf="producto.params?.sequence?.BS?.list" class="product-sequence mb-2">
                <span class="sequence-label">Secuencia:</span>
                <div class="sequence-amounts">
                  <span *ngFor="let monto of producto.params?.sequence?.BS?.list" 
                        class="badge me-1"
                        [class.bg-warning]="monto === producto.params?.sequence?.BS?.default"
                        [class.bg-secondary]="monto !== producto.params?.sequence?.BS?.default">
                    {{ monto }} BS
                    <i *ngIf="monto === producto.params?.sequence?.BS?.default" 
                       class="fas fa-star ms-1" 
                       title="Por defecto"></i>
                  </span>
                </div>
              </div>
              
              <div class="product-details">
                <small class="text-muted">
                  Orden: {{ producto.order }}
                </small>
              </div>
              <div class="item-metadata">
                <small class="text-muted">
                  Cliente: {{ producto.showClient ? 'Sí' : 'No' }} | 
                  Consola: {{ producto.showConsole ? 'Sí' : 'No' }}
                </small>
              </div>
            </div>

            <!-- Actions -->
            <div class="item-actions">
              <!-- Status Toggle -->
              <div class="form-check form-switch">
                <input class="form-check-input" 
                       type="checkbox" 
                       [id]="'toggle-prod-' + producto.code"
                       [checked]="producto.status"
                       [disabled]="togglingProducto[producto.code]"
                       (change)="toggleProductoStatus(producto)">
                <label class="form-check-label" [for]="'toggle-prod-' + producto.code">
                  <span [class]="producto.status ? 'text-success' : 'text-danger'">
                    {{ producto.status ? 'Activo' : 'Inactivo' }}
                  </span>
                </label>
              </div>

              <!-- Edit Sequence Button -->
              <button class="btn btn-outline-secondary btn-sm"
                      (click)="onEditSequence(producto)"
                      title="Editar secuencia de montos">
                <i class="fas fa-edit me-1"></i>Editar Secuencia
              </button>
            </div>
          </div>

          <!-- Loading overlay -->
          <div *ngIf="togglingProducto[producto.code]" class="loading-overlay">
            <div class="spinner-border spinner-border-sm text-primary"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Edición de Secuencia -->
<div class="modal fade" 
     [class.show]="isEditingSequence" 
     [style.display]="isEditingSequence ? 'block' : 'none'"
     tabindex="-1" 
     *ngIf="isEditingSequence">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      
      <!-- Header del Modal -->
      <div class="modal-header">
        <h5 class="modal-title">
          <i class="fas fa-cog me-2"></i>Editar Secuencia
        </h5>
        <button type="button" class="btn-close" (click)="onCloseSequenceModal()"></button>
      </div>

      <!-- Body del Modal -->
      <div class="modal-body">
        
        <!-- Información del Producto -->
        <div class="edit-product-header mb-4" *ngIf="editingProduct">
          <h6 class="product-name">{{ editingProduct.name }}</h6>
          <small class="text-muted">{{ editingProduct.description }}</small>
        </div>

        <!-- Error Message -->
        <div class="alert alert-danger alert-sm" *ngIf="sequenceError">
          <i class="fas fa-exclamation-triangle me-2"></i>{{ sequenceError }}
        </div>

        <!-- Input para agregar montos -->
        <div class="add-amount-section mb-4">
          <label class="form-label">Agregar nuevo monto</label>
          <div class="input-group">
            <input type="number" 
                   class="form-control" 
                   placeholder="Ingrese monto"
                   #newAmountInput
                   min="1"
                   step="1">
            <span class="input-group-text">BS</span>
            <button class="btn btn-primary" 
                    type="button" 
                    (click)="onAddNewAmount(newAmountInput.value); newAmountInput.value = ''">
              <i class="fas fa-plus me-2"></i>Agregar
            </button>
          </div>
        </div>

        <!-- Montos actuales con diseño de chips -->
        <div class="current-amounts-section" *ngIf="editingSequence?.BS?.list?.length">
          <label class="form-label">Montos disponibles ({{ editingSequence.BS.list.length }})</label>
          
          <div class="amounts-chips-grid">
            <div *ngFor="let amount of editingSequence.BS.list; trackBy: trackByMonto"
                 class="amount-chip-editable"
                 [class.default-chip-editable]="amount === editingSequence.BS.default">
              
              <div class="chip-content-editable">
                <span class="monto-principal-editable">{{ amount }}</span>
                <span class="monto-currency-editable">BS</span>
              </div>

              <!-- Selector por defecto mejorado -->
              <div class="default-toggle" 
                   (click)="onSetDefault(amount)"
                   [class.active]="amount === editingSequence.BS.default"
                   title="Establecer como por defecto">
                <div class="toggle-circle"></div>
                <span class="toggle-label">Por defecto</span>
              </div>

              <!-- Botón de eliminar -->
              <div class="chip-actions">
                <button type="button" 
                        class="btn-delete"
                        (click)="onRemoveAmount(amount)"
                        [disabled]="editingSequence.BS.list.length <= 1"
                        title="Eliminar monto">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Estado vacío -->
        <div class="empty-amounts" *ngIf="!editingSequence?.BS?.list?.length">
          <div class="empty-content">
            <i class="fas fa-coins empty-icon"></i>
            <p class="empty-text">No hay montos configurados</p>
            <small class="text-muted">Agregue al menos un monto para continuar</small>
          </div>
        </div>

        <!-- Información del monto por defecto -->
        <div class="default-info-modal mt-3" *ngIf="editingSequence?.BS?.default">
          <small class="text-warning">
            <i class="fas fa-info-circle me-1"></i>
            <strong>{{ editingSequence.BS.default }} BS</strong> es el monto por defecto
          </small>
        </div>
      </div>

      <!-- Footer del Modal -->
      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="onCloseSequenceModal()" [disabled]="isSavingSequence">
          Cancelar
        </button>
        <button type="button" class="btn btn-primary" (click)="onSaveSequence()" [disabled]="isSavingSequence || !editingSequence?.BS?.list?.length">
          <span class="spinner-border spinner-border-sm me-2" *ngIf="isSavingSequence"></span>
          <i class="fas fa-save me-2" *ngIf="!isSavingSequence"></i>
          {{ isSavingSequence ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop del Modal -->
<div class="modal-backdrop fade show" *ngIf="isEditingSequence" (click)="onCloseSequenceModal()"></div>
